<template>
  <img :src="src" :srcset="srcset" :title="title" @click="handleClick" />
</template>

<script>
export default {
  name: "MultiImage",
  props: {
    name: String,
    title: String,
  },
  computed: {
    src() {
      return this.$store.getters[this.name].src;
    },
    srcset() {
      return this.$store.getters[this.name].srcset;
    },
  },
  methods: {
    handleClick: function() {
      this.$emit("click");
    },
  },
};
</script>
